import { SideBarContainer } from 'components/Custom/SideBarContainer'
import { Box } from 'components/Material/index'
import { useIsMobile } from 'hooks/useIsResponsive'
import { DocumentViewerFormalizationBody } from './DocumentViewerFormalizationBody'

const DocumentViewerFormalization = () => {
  const isMobile = useIsMobile()

  return isMobile ? (
    <SideBarContainer>
      <DocumentViewerFormalizationBody />
    </SideBarContainer>
  ) : (
    <Box
      className="flex bg-black  absolute w-screen h-screen"
      style={{
        position: 'absolute',
        left: 0,
        right: 0,
        zIndex: 1000
      }}
    >
      <DocumentViewerFormalizationBody />
    </Box>
  )
}

export default DocumentViewerFormalization
